import { inject, Injectable } from '@angular/core';

import { from, Observable, of, Subject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { VERSION } from '@core/tokens/version.token';
import { environment } from '@env';
import { Environment } from '@interfaces/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  readonly version: string = inject(VERSION);

  environment: Environment;

  private readonly isConfigReady$ = new Subject();

  appConfigFactory<T>(fn: (...args: unknown[]) => unknown): () => Promise<T> {
    return (): Promise<T> =>
      new Promise((resolve, reject) =>
        this.isConfigReady$
          .pipe(
            filter(isConfigReady => !!isConfigReady),
            tap(() => fn()),
            tap({ next: resolve, error: reject })
          )
          .subscribe()
      );
  }

  loadEnvironment(): Observable<Environment> {
    const loadEnvironmentObs = environment.dynamic
      ? from(fetch('assets/config/app-config.json').then(response => response.json()))
      : of(environment);

    return loadEnvironmentObs.pipe(
      tap((loadedEnvironment: Environment) => {
        this.environment = loadedEnvironment;
        this.isConfigReady$.next(true);
      })
    );
  }
}
